// constants.js
import * as Yup from "yup";

export const modelDataRequest = {
  id: 0, id_workflow_status: 0, id_user: 0, id_messenger: 0,
  ref_no: "", service_date: "", document_type: "", service_request: "",
  delivery_section: "", delivery_type: "", document_secret: "",
  pickup_location: "", sender_name: "", sender_tel: "", sender_id_bu: "",
  sender_department: "", receiver_name: "", receiver_tel: "", receiver_company: "",
  receiver_department: "", receiver_building: "", receiver_floor: "",
  receiver_district: "", is_complete_today: "", time_complete_today: "",
  note: "", status: "1", receiver_province: "",
  receiver_map: "",
  messenger: null,
};

export const isDocumentDelivery = (val) => String(val) === "1";

// ── เช็คว่าเวลาที่กรอกไม่ใช่เวลาที่ผ่านมาแล้ว (เฉพาะกรณี service_date = วันนี้) ──
export const isCompletionTimeNotPast = (serviceDateStr, timeStr) => {
  if (!timeStr || !serviceDateStr) return true;
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  if (serviceDateStr !== todayStr) return true;

  const [h, m] = timeStr.split(":").map(Number);
  const selected = new Date();
  selected.setHours(h, m, 0, 0);
  return selected >= now;
};

export const buildValidationSchema = () =>
  Yup.object({
    service_date:     Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
    pickup_location:  Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
    service_type:     Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
    document_secret:  Yup.number().typeError("กรุณากรอกข้อมูล/Please fill out").required("กรุณากรอกข้อมูล/Please fill out"),
    delivery_section: Yup.number().typeError("กรุณากรอกข้อมูล/Please fill out").required("กรุณากรอกข้อมูล/Please fill out"),
    is_complete_today: Yup.number().typeError("กรุณากรอกข้อมูล/Please fill out").required("กรุณากรอกข้อมูล/Please fill out"),
    time_complete_today: Yup.string().when("is_complete_today", {
      is: 2,
      then: (s) => s.trim().required("กรุณากรอกข้อมูล/Please fill out")
        .test(
          "not-in-past",
          "ไม่สามารถเลือกเวลาที่ผ่านมาแล้วได้",
          function (value) {
            const { service_date } = this.parent;
            return isCompletionTimeNotPast(service_date, value);
          }
        ),
      otherwise: (s) => s.notRequired(),
    }),

    // service_type=1 เท่านั้น
    delivery_type: Yup.number().typeError("กรุณากรอกข้อมูล/Please fill out").nullable().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired().nullable(),
    }),
    receiver_name: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_tel: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_company: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_department: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_building: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_floor: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_district: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_province: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),

    // service_type=2 หรือ 3 เท่านั้น
    id_provider: Yup.string().when("service_type", {
      is: (v) => String(v) === "2" || String(v) === "3",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    id_provider_branch: Yup.string().when("service_type", {
      is: (v) => String(v) === "2" || String(v) === "3",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),

    // other_branch_name — required เมื่อเลือก อื่นๆ (ทั้ง service_type=2 และ 3)
    other_branch_name: Yup.string().when("id_provider_branch", {
      is: "other",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),

    // service_type=3 เท่านั้น
    id_sub_service_type3: Yup.string().when("service_type", {
      is: (v) => String(v) === "3",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
  });

export const buildDestinationValidationSchema = () =>
  Yup.object({
    pickup_location:  Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
    service_type:     Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
    is_complete_today: Yup.number().typeError("กรุณากรอกข้อมูล/Please fill out").required("กรุณากรอกข้อมูล/Please fill out"),
    time_complete_today: Yup.string().when("is_complete_today", {
      is: 2,
      then: (s) => s.trim().required("กรุณากรอกข้อมูล/Please fill out")
        // ── ห้ามเลือกเวลาที่ผ่านมาแล้ว ถ้า service_date (ของ main form) คือวันนี้ ──
        .test(
          "not-in-past",
          "ไม่สามารถเลือกเวลาที่ผ่านมาแล้วได้",
          function (value) {
            const { service_date } = this.parent;
            return isCompletionTimeNotPast(service_date, value);
          }
        ),
      otherwise: (s) => s.notRequired(),
    }),

    delivery_type: Yup.number().typeError("กรุณากรอกข้อมูล/Please fill out").nullable().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired().nullable(),
    }),
    receiver_name: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_tel: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_company: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_department: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_building: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_floor: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_province: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    receiver_district: Yup.string().when("service_type", {
      is: (v) => isDocumentDelivery(v),
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),

    id_provider: Yup.string().when("service_type", {
      is: (v) => String(v) === "2" || String(v) === "3",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    id_provider_branch: Yup.string().when("service_type", {
      is: (v) => String(v) === "2" || String(v) === "3",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    other_branch_name: Yup.string().when("id_provider_branch", {
      is: "other",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
    id_sub_service_type3: Yup.string().when("service_type", {
      is: (v) => String(v) === "3",
      then: (s) => s.required("กรุณากรอกข้อมูล/Please fill out"),
      otherwise: (s) => s.notRequired(),
    }),
  });